import { motion } from "framer-motion";
import FoldText from "@/components/FoldText/FoldText";
import OptionButton from "@/components/ripOffDetector/OptionButton";

const EASE = [0.16, 1, 0.3, 1];

const QuestionCard = ({ question, selectedOption, onSelect }) => (
  <motion.div
    key={question.id}
    initial={{ opacity: 0, x: 24 }}
    animate={{ opacity: 1, x: 0 }}
    exit={{ opacity: 0, x: -24 }}
    transition={{ duration: 0.5, ease: EASE }}
    data-testid={`detector-question-${question.id}`}
    className="relative bg-[#121214] border border-white/10 p-6 sm:p-8"
  >
    <div className="absolute -top-3 -left-3 w-8 h-8 border-t-2 border-l-2 border-[#8A2BE2]/50" />
    <div className="absolute -bottom-3 -right-3 w-8 h-8 border-b-2 border-r-2 border-[#8A2BE2]/50" />

    <h2 className="font-display font-semibold text-xl sm:text-2xl !leading-[1.3] text-white">
      <FoldText
        text={question.question}
        splitBy="word"
        trigger="mount"
        fontSize="inherit"
        fontWeight="inherit"
        color="inherit"
        stagger={0.02}
      />
    </h2>

    <div className="mt-6 space-y-3">
      {question.options.map((option, i) => (
        <OptionButton
          key={option}
          label={option}
          selected={selectedOption === option}
          onClick={() => onSelect(question.id, option)}
          testId={`detector-option-${question.id}-${i}`}
        />
      ))}
    </div>
  </motion.div>
);

export default QuestionCard;
